

import React, { useState, useEffect } from 'react';
import { ChevronLeft, Edit2, Tag, ChevronDown, ChevronUp, Plus, Minus, Trash2, X } from 'lucide-react';
import { useNavigate, useLocation } from "react-router-dom";
import { fetchUserFromRedis } from "../AuthonticationPages/Register";
import CustomDialog from "../../CustomDialog";
import addressConfig from "../../Configurations/addressConfig.json";
import TIME_SLOTS from "../../Configurations/timeslots.json";
import axios from 'axios';
import { apiRequest } from '../../fetchSetup';
import {
  Checkbox, FormControlLabel,Typography
} from "@mui/material";

const COMMUNITY_OPTIONS = addressConfig.communities;
const BLOCK_OPTIONS = addressConfig.blocks;

const MedicineDeliveryAddressScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    orderType,
    diagnosticOrderData,
    serviceTitle,
    servicePrice,
    selectedDate,
    appointmentDateTime,
    patientDetails,
    cart: initialCart,
    patientInfo,
    prescription,
    totalAmount: initialTotal,
    prescriptionFile,
    prescriptionPreview,
  } = location.state || {};

  // ─── AYUJA pricing data ────────────────────────────────────────────────────
  const ayujaData = React.useMemo(() => {
    try {
      return JSON.parse(sessionStorage.getItem('ayujaPricing') || '{}');
    } catch { return {}; }
  }, []);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Promo
  const [promoCode, setPromoCode] = useState("");
  const [appliedPromo, setAppliedPromo] = useState(null);
  const [promoLoading, setPromoLoading] = useState(false);
  const [showAvailablePromos, setShowAvailablePromos] = useState(false);
  const [availablePromos, setAvailablePromos] = useState([]);
  const [promoMsg, setPromoMsg] = useState("")
  const [promotype, setPromotype] = useState("")
  // Subscription
  const [subscriptionBenefits, setSubscriptionBenefits] = useState(null);
  const [subscriptionDiscount, setSubscriptionDiscount] = useState(0);
  const [loadingSubscription, setLoadingSubscription] = useState(false);
  const [acceptedTerms,setAcceptedTerms]=useState(false)
  const [communities, setCommunities] = useState([]);
  // Cart — initialised from location.state first, then sessionStorage fallback
  const [cart, setCart] = useState(() => {
    // For diagnostic orders
    if (orderType === "diagnostic") {
      if (diagnosticOrderData?.tests?.length > 0) return diagnosticOrderData.tests;
      if (initialCart?.length > 0) return initialCart;
      try {
        const saved = sessionStorage.getItem('diagnosticOrderData');
        const parsed = saved ? JSON.parse(saved) : null;
        if (parsed?.tests?.length > 0) return parsed.tests;
      } catch { /* ignore */ }
      return [];
    }

    // For medicine/pharmacy orders
    // ✅ Priority 1: sessionStorage pharmacyCart (AYUJA prices already embedded)
    const savedCart = sessionStorage.getItem('pharmacyCart');
    if (savedCart) {
      try {
        const parsed = JSON.parse(savedCart);
        if (Array.isArray(parsed) && parsed.length > 0) {
          console.log('Medicine cart restored from sessionStorage');
          return parsed;
        }
      } catch { /* ignore */ }
    }
    // ✅ Priority 2: initialCart from location.state
    if (initialCart?.length > 0) return initialCart;
    return [];
  });

  const [formData, setFormData] = useState(() => {
    const savedAddress = sessionStorage.getItem('pharmacyDeliveryAddress');
    if (savedAddress) {
      try { return JSON.parse(savedAddress); } catch { /* ignore */ }
    }
    return {
      full_name: "", email: "", phone: "", community_name: "",
      address_line1: "", address_line2: "", landmark: "",
      address_type: "home", delivery_time_option: "anytime", delivery_time: "",
    };
  });

  const [originalFormData, setOriginalFormData] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [errors, setErrors] = useState({});
  const [selecctedDate, setSelectedDate] = useState("");
  const [isEditingAddress, setIsEditingAddress] = useState(false);

  // ─── Add unique IDs to cart items ─────────────────────────────────────────
  useEffect(() => {
    setCart(prev =>
      prev.map((item, index) => ({
        ...item,
        id: item.id || item.medicine_id || `${index}_${Date.now()}`,
      }))
    );
  }, []);
 useEffect(() => {
      fetchCommunities()
     },[])
    const fetchCommunities = async () => {
    
        try {
    
          const response = await axios.get(
            `${process.env.REACT_APP_API}/community/config`
          );
    
          setCommunities(
            response.data.communities || []
          );
          sessionStorage.setItem("communities",JSON.stringify(response.data.communities))
    
        } catch (error) {
    
          console.error(
            "Error fetching communities:",
            error
          );
    
          
    
        } 
      };
    
  
  // ─── Sync cart to sessionStorage ──────────────────────────────────────────
  useEffect(() => {

    if (orderType === "diagnostic") {
  const mrpSum = cart.reduce((s, i) => s + (Number(i.mrp) || 0) * (Number(i.quantity) || 1), 0);
  const totalSum = cart.reduce((s, i) => s + (Number(i.non_membership) || Number(i.price) || Number(i.mrp) || 0) * (Number(i.quantity) || 1), 0);
  sessionStorage.setItem('diagnosticOrderData', JSON.stringify({
    tests: cart, total_amount: totalSum, mrp_total: mrpSum,
    savings: Math.max(0, mrpSum - totalSum), test_count: cart.length,
  }));

    } else if (orderType === "medicine" || orderType === "pharmacy") {
      const validMedicines = cart.filter(item => item.medicine_id);
      if (validMedicines.length > 0) {
        sessionStorage.setItem('pharmacyCart', JSON.stringify(validMedicines));
      }
    }
  }, [cart, orderType]);

  // ─── Subscription fetch ────────────────────────────────────────────────────
  useEffect(() => {
    const fetchSubscriptionBenefits = async () => {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      if (!userId || !token) return;
      const apiBaseUrl = process.env.REACT_APP_PRICING_API;
      if (!apiBaseUrl) return;
      setLoadingSubscription(true);
      try {
        const response = await axios.get(`${apiBaseUrl}/check-benefits/${userId}`, {
          headers: { "Content-Type": "application/json" },
        });
        const data = response.data;
        if (data?.success && data?.has_subscription) setSubscriptionBenefits(data);
      } catch (error) {
        console.error("Error fetching subscription benefits:", error);
      } finally {
        setLoadingSubscription(false);
      }
    };
    fetchSubscriptionBenefits();
  }, []);

  // ─── Auto-save formData ────────────────────────────────────────────────────
  useEffect(() => {
    if (formData.full_name || formData.email || formData.phone) {
      sessionStorage.setItem('pharmacyDeliveryAddress', JSON.stringify(formData));
    }
  }, [formData]);

  // ─── Available promos fetch ────────────────────────────────────────────────
  useEffect(() => {
    const fetchAvailablePromos = async () => {
      try {
        const userId = sessionStorage.getItem("userId");
        const response = await axios.get(
          `${process.env.REACT_APP_APPLY_PROMOTION_API}/available?service_type=${orderType}&user_id=${userId}`,
          { headers: { "Content-Type": "application/json" } }
        );
        const data = response.data;
        if (data?.success) setAvailablePromos(data.promotions || []);
      } catch (error) {
        console.error("Error fetching promos:", error);
      }
    };
    fetchAvailablePromos();
  }, []);

  // ─── User / address fetch ──────────────────────────────────────────────────
  useEffect(() => {
    const loadUserData = async () => {
      const savedAddress = sessionStorage.getItem('pharmacyDeliveryAddress');
      const parsedSavedAddress = savedAddress ? JSON.parse(savedAddress) : null;


      
// PRIORITY 1: patientDetails or patientInfo (diagnostic flow uses patientInfo) with phone
const contactPhone = patientDetails?.phone || patientInfo?.phone;
const contactName = patientDetails?.name || patientInfo?.name;

if (contactPhone) {
  try {
    const apiUrl = process.env.REACT_APP_GET_USER_BY_PHONE_API;
    let cleanedPhone = contactPhone.trim().replace(/^\+?91/, '').replace(/[\s-]/g, '');
    const response = await axios.get(`${apiUrl}/${cleanedPhone}`, {
      headers: { "Content-Type": "application/json" },
    });
    const data = response.data;
    if (data?.success && data?.user) {
      const fetchedAddress = {
        full_name: data.user.name || contactName || "",
        email: data.user.email || "",
        phone: data.user.phone || contactPhone || "",
        community_name: data.user.address?.community_name || "",
        address_line1: data.user.address?.address_line1 || "",
        address_line2: data.user.address?.address_line2 || "",
        landmark: data.user.address?.landmark || "",
        address_type: data.user.address?.address_type || "home",
        delivery_time_option: "anytime", delivery_time: "",
      };
      setFormData(fetchedAddress);
      sessionStorage.setItem('pharmacyDeliveryAddress', JSON.stringify(fetchedAddress));
      setLoading(false);
      return;
    }
  } catch (error) {
    console.error("Error fetching user by phone:", error);
  }
  const patientAddress = {
    full_name: contactName || "", email: patientDetails?.email || patientInfo?.email || "",
    phone: contactPhone || "",
    community_name: parsedSavedAddress?.community_name || "",
    address_line1: parsedSavedAddress?.address_line1 || "",
    address_line2: parsedSavedAddress?.address_line2 || "",
    landmark: parsedSavedAddress?.landmark || "",
    address_type: parsedSavedAddress?.address_type || "home",
    delivery_time_option: "anytime", delivery_time: "",
  };
  setFormData(patientAddress);
  sessionStorage.setItem('pharmacyDeliveryAddress', JSON.stringify(patientAddress));
  setLoading(false);
  return;
}
      // PRIORITY 2: sessionStorage
      const hasUserEnteredData = parsedSavedAddress && (parsedSavedAddress.community_name || parsedSavedAddress.address_line1);
      if (hasUserEnteredData) { setFormData(parsedSavedAddress); setLoading(false); return; }

      // PRIORITY 3: Redis
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      if (!userId || !token) { setUser(null); setLoading(false); return; }
      try {
        const userData = await fetchUserFromRedis(userId, token);
        if (userData) {
          setUser(userData);
          if (userData.address) {
            const loadedAddress = {
              full_name: userData.address.full_name || userData.name || "",
              email: userData.email || "", phone: userData.address.phone || userData.phone || "",
              community_name: userData.address.community_name || "",
              address_line1: userData.address.address_line1 || "",
              address_line2: userData.address.address_line2 || "",
              landmark: userData.address.landmark || "",
              address_type: userData.address.address_type || "home",
              delivery_time_option: "anytime", delivery_time: "",
            };
            setFormData(loadedAddress);
            sessionStorage.setItem('pharmacyDeliveryAddress', JSON.stringify(loadedAddress));
          }
        }
      } catch (err) { setUser(null); }
      finally { setLoading(false); }
    };
    loadUserData();
  // }, [patientDetails]);
  }, [patientDetails, patientInfo]);

  // ─── Promo re-validate on cart change ─────────────────────────────────────
  const justAppliedPromo = React.useRef(false);

  useEffect(() => {
    if (appliedPromo) validateAppliedPromo();
  }, [cart]); // eslint-disable-line
  const community=sessionStorage.getItem("community")
  // ─── ALL TOTALS — computed directly from cart.discounted_price ─────────────
   const deliveryCharge = (formData.community_name) !== "Honer Vivantis"
    ? Number(process.env.REACT_APP_DELIVERY_CHARGE) || 0:0;
  const discountAmount = appliedPromo ? Number(appliedPromo.discount) || 0 : 0;

  // Medicine totals (AYUJA-aware)
  const mrpTotal = cart.reduce((s, i) => {
  const qty = Number(i.quantity) || 1;
  if (orderType === "diagnostic") return s + (Number(i.mrp) || 0) * qty;
  return s + (Number(i.price) || 0) * qty;
}, 0);

const sellingTotal = cart.reduce((s, i) => {
  const qty = Number(i.quantity) || 1;
  if (orderType === "diagnostic") {
    return s + (Number(i.non_membership) || Number(i.price) || Number(i.mrp) || 0) * qty;
  }
  return s + (Number(i.discounted_price) || Number(i.price) || 0) * qty;
}, 0);

  const ayujaSavings = orderType !== "diagnostic" ? Math.max(0, mrpTotal - sellingTotal) : 0;
  const diagnosticSavings = orderType === "diagnostic" ? Math.max(0, mrpTotal - sellingTotal) : 0;
  const ayujaDiscPct = mrpTotal > 0 ? (ayujaSavings / mrpTotal * 100).toFixed(1) : "0.0";

  // Per-item derived values (for the AYUJA savings banner)
  const perItemDiscPct = mrpTotal > 0 ? (ayujaSavings / mrpTotal) * 100 : 0;
  const orderBP = cart.reduce((s, i) => s + (Number(i.base_price) || 0) * (Number(i.quantity) || 1), 0);
  const orderMaxDisc = mrpTotal - orderBP;
  const orderMaxDiscPct = mrpTotal > 0 ? (orderMaxDisc / mrpTotal) * 100 : 0;
  const alphaValue = orderMaxDiscPct > 0 ? perItemDiscPct / orderMaxDiscPct : 0;
  const configuredDiscPct = 20;
  const wasCapped = perItemDiscPct < configuredDiscPct - 0.5;

  // ─── Subscription discount (keyed off sellingTotal) ────────────────────────
  useEffect(() => {
    if (subscriptionBenefits?.has_subscription) {
      const pct = subscriptionBenefits.benefits.medicine_discount || 0;
      setSubscriptionDiscount((sellingTotal * pct) / 100);
    } else {
      setSubscriptionDiscount(0);
    }
  }, [cart, subscriptionBenefits]); // eslint-disable-line

  const finalAmount = Math.max(0, sellingTotal + deliveryCharge - subscriptionDiscount - discountAmount);

  // ─── Promo helpers ─────────────────────────────────────────────────────────
  const applyPromoCode = async (code) => {
    const userId = sessionStorage.getItem("userId");
    const payload = {
      promo_code: code.toUpperCase(),
      service_type:orderType,
      order_price: sellingTotal,
      user_id: userId,
      test_ids: cart.map(test =>  ({
      test_name:test.test_name,
      test_id: test.test_id,
      price: test.price, // or the correct price field you're using
    })),
      categories: [
        ...new Set(cart.map(test => test.category))
      ]
    };
    setPromoLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APPLY_PROMOTION_API}/apply`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );
      const data = response.data;
      if (data.success) {
        justAppliedPromo.current = true;
        setAppliedPromo({ code: data.promo_code, discount: data.discount_amount, title: data.title,affected_tests:data.affected_tests });
        setPromoCode(""); setShowAvailablePromos(false);
        setPromoMsg("Applied")
        setPromotype("success")
        setDialogMessage(data.message || "Promo code applied successfully!"); setDialogOpen(true);
      } else {
        setPromoMsg("Invalid")
        setPromotype("error")
        setDialogMessage(data.error || "Invalid promo code"); setDialogOpen(true);
      }
    } catch {
      setPromoMsg("Invalid")
      setDialogMessage("Failed to apply promo code. Please try again."); setDialogOpen(true);
    } finally {
      setPromoLoading(false);
    }
  };

  const validateAppliedPromo = async () => {
    if (!appliedPromo) return;
    if (justAppliedPromo.current) { justAppliedPromo.current = false; return; }
    try {
      const userId = sessionStorage.getItem("userId");
      const response = await axios.post(
        `${process.env.REACT_APP_APPLY_PROMOTION_API}/apply`,
        { promo_code: appliedPromo.code, service_type: orderType, order_price: sellingTotal, user_id: userId },
        { headers: { "Content-Type": "application/json" } }
      );
      const data = response.data;
      if (!data.success) {
        setAppliedPromo(null);
        setDialogMessage(`Promo "${appliedPromo.code}" removed. ${data.error || "Cart no longer meets requirements."}`);
        setDialogOpen(true);
      } else if (data.discount_amount !== appliedPromo.discount) {
        setPromoMsg("Applied")
        setPromotype("success")
        setAppliedPromo({ code: data.promo_code, discount: data.discount_amount, title: data.title ,affected_tests:data.affected_tests});
      }
    } catch { setAppliedPromo(null); }
  };

  const removePromoCode = () => {
    setAppliedPromo(null); setDialogMessage("Promo code removed"); setDialogOpen(true);setPromoMsg("Removed!")
  };

  const recalculateCart = async (updatedCart) => {
  try {
    const response = await apiRequest(
              `${process.env.REACT_APP_MEDICINE_API_URL}/calculate-order-price`,
              {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  items: updatedCart.map(i => ({
                    medicine_id: i.medicine_id,
                    quantity: i.quantity,
                  })),
                }),
              }
            );
    
            if (!response.ok) {
              console.error('AYUJA fetch failed:', response.status, await response.text());
              return;
            }
    

    const pricing = await response.json();

    const mergedCart = updatedCart.map(item => {
      const backendItem = pricing.item_breakdown.find(
        x => x.medicine_id === item.id
      );

      if (!backendItem) return item;

      return {
        ...item,
        discounted_price: backendItem.selling_price,
        discount_percentage: backendItem.discount_pct,
        total: backendItem.selling_price * item.quantity,
      };
    });

    setCart(mergedCart);
    sessionStorage.setItem("pharmacyCart", JSON.stringify(mergedCart));

  } catch (err) {
    console.error(err);
  }
};


// ─── Diagnostic quantity controls (no backend recalculation needed) ───────
const updateDiagnosticQuantity = (itemId, change) => {
  setCart(prevCart => {
    const updatedCart = prevCart
      .map(item => (item.id === itemId || item.test_id === itemId)
        ? { ...item, quantity: (Number(item.quantity) || 1) + change }
        : item)
      .filter(item => (Number(item.quantity) || 1) > 0);
    return updatedCart;
  });
  if (appliedPromo) setAppliedPromo(null);
};

const removeDiagnosticItem = (itemId) => {
  setCart(prevCart => prevCart.filter(item => (item.id || item.test_id) !== itemId));
  if (appliedPromo) setAppliedPromo(null);
};


  // ─── Cart quantity controls ────────────────────────────────────────────────
  const updateQuantity = (itemId, change) => {
    setCart(prevCart => {
      const updatedCart = prevCart
        .map(item => item.id === itemId ? { ...item, quantity: item.quantity + change } : item)
        .filter(item => item.quantity > 0);
      recalculateCart(updatedCart);
      sessionStorage.setItem("pharmacyCart", JSON.stringify(updatedCart));
      return updatedCart;
    });
    if (appliedPromo) setAppliedPromo(null);
  };

  const removeItem = (itemId) => {
    setCart(prevCart => {
      const updatedCart = prevCart.filter(item => item.id !== itemId);
      sessionStorage.setItem("pharmacyCart", JSON.stringify(updatedCart));
      recalculateCart(updatedCart);

      return updatedCart;
    });
    if (appliedPromo) setAppliedPromo(null);
  };

  // ─── Delivery time helpers ─────────────────────────────────────────────────
  const handleDateChange = (dateString) => {
    setSelectedDate(dateString);
    setSelectedSlot("");
    handleInputChange("delivery_time", "");
    const selected = new Date(dateString);
    const now = new Date();
    const isToday = selected.toDateString() === now.toDateString();
    setAvailableSlots(TIME_SLOTS.map(slot => ({
      ...slot, disabled: isToday && now.getHours() >= slot.end,
    })));
  };

  const handleInputChange = (field, value) => {
    const updated = { ...formData, [field]: value };
    setFormData(updated);
    sessionStorage.setItem('pharmacyDeliveryAddress', JSON.stringify(updated));
    if (errors[field]) setErrors(prev => ({ ...prev, [field]: "" }));
  };

  const handleEditAddress = () => { setOriginalFormData({ ...formData }); setIsEditingAddress(true); };
  const handleCancelEdit = () => {
    if (originalFormData) {
      setFormData(originalFormData);
      sessionStorage.setItem('pharmacyDeliveryAddress', JSON.stringify(originalFormData));
    }
    setErrors({}); setSelectedDate(""); setSelectedSlot(""); setIsEditingAddress(false);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.full_name.trim()) newErrors.full_name = "Full name is required";
    else if (formData.email &&  !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = "Please enter a valid email address";
    if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
    else if (!/^\d{10}$/.test(formData.phone)) newErrors.phone = "Please enter a valid 10-digit phone number";
    if (!formData.community_name.trim()) newErrors.community_name = "Community/Society name is required";
    if (!formData.address_line1.trim()) newErrors.address_line1 = "Block/Building is required";
    if (formData.delivery_time_option === "specific") {
      if (!selecctedDate) newErrors.selecctedDate = "Please select a delivery date";
      if (!formData.delivery_time) newErrors.delivery_time = "Please select a delivery time slot";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const applySubscriptionToOrder = async () => {
    if (!subscriptionBenefits?.has_subscription) return null;
    const userId = sessionStorage.getItem("userId");
    const apiBaseUrl = process.env.REACT_APP_PRICING_API;
    if (!apiBaseUrl) return null;
    try {
      const response = await axios.post(`${apiBaseUrl}/apply-subscription`,
        { user_id: userId, service_type: orderType, base_price: sellingTotal },
        { headers: { "Content-Type": "application/json" } }
      );
      return response.data || null;
    } catch { return null; }
  };

  const handleSaveAddress=async(addressData)=>{
     try {
      
      const token = sessionStorage.getItem("token");
      
      if (!token) {
        console.error("No authentication token found");
        return false;
      }

      const response = await apiRequest(process.env.REACT_APP_UPDATE_USER_PROFILE_API, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          address:{full_name: addressData.full_name,
                phone: addressData.phone,
                community_name: addressData.community_name ||"",
                address_line1: addressData.address_line1 ||"",
                address_line2: addressData.address_line2 ||""}
        })
      });

      const data = await response.json();
  }
  catch (error) {
      console.error("Error Saving Address:", error);
      return false;
    }
}

  const handleProceed = async () => {
    if (cart.length === 0) { setDialogMessage("Your cart is empty."); setDialogOpen(true); return; }
    if (!validateForm()) { setDialogMessage("Please fill all required fields correctly"); setDialogOpen(true); return; }
    try {
      sessionStorage.setItem('pharmacyCart', JSON.stringify(cart));
      sessionStorage.setItem('pharmacyPatientDetails', JSON.stringify(patientDetails));
      const deliveryAddress = {
        ...formData,
        delivery_time_option: formData.delivery_time_option,
        delivery_time: formData.delivery_time_option === "anytime" ? "Anytime" : formData.delivery_time,
        delivery_date: selecctedDate,
      };
      sessionStorage.setItem('pharmacyDeliveryAddress', JSON.stringify(deliveryAddress));
      if (orderType === "diagnostic" && diagnosticOrderData) {
        sessionStorage.setItem('diagnosticOrderData', JSON.stringify(diagnosticOrderData));
      }
      if (prescriptionFile) sessionStorage.setItem('pharmacyPrescription', prescriptionFile);

      const subscriptionResponse = await applySubscriptionToOrder();
      const subscriptionData = subscriptionResponse || {
        applied: subscriptionBenefits?.has_subscription || false,
        discount_amount: subscriptionDiscount,
        subscription_name: subscriptionBenefits?.subscription?.name || null,
        subscription_id: subscriptionBenefits?.subscription?.subscription_id || null,
        discount_percent: subscriptionBenefits?.benefits?.medicine_discount || 0,
      };

      const route = orderType === "diagnostic" ? "/select-payment-method" : "/MedicinePayment";
      const payload = {
        orderType,
        totalAmount: finalAmount, // ✅ correct final payable (AYUJA-aware)
        userEmail: formData.email,
        userPhone: formData.phone,
        deliveryAddress,
        cart,
        patientDetails,
        prescriptionFile,
        prescriptionPreview,
        appliedPromo,
        subscriptionDiscount: subscriptionData.discount_amount,
        promoDiscount: appliedPromo ? appliedPromo.discount : 0,
        promoCode: appliedPromo ? appliedPromo.code : "",
        subscriptionBenefits,
      };
      if (orderType === "diagnostic") {
        payload.diagnosticOrderData = {
          tests: diagnosticOrderData?.tests || cart,
          total_amount: diagnosticOrderData?.total_amount || servicePrice,
          mrp_total: diagnosticOrderData?.mrp_total || servicePrice,
          savings: diagnosticOrderData?.savings || 0,
          test_count: diagnosticOrderData?.tests?.length || 0,
        };
        payload.serviceTitle = serviceTitle; payload.servicePrice = servicePrice;
        payload.selectedDate = selectedDate; payload.appointmentDateTime = appointmentDateTime;
        payload.patientInfo = patientInfo; payload.name = patientInfo?.name;
        payload.email = patientInfo?.email; payload.phone = patientInfo?.phone;
        payload.gender = patientInfo?.gender; payload.dob = patientInfo?.dob;
      }

      if (["medicine", "pharmacy"].includes(orderType)) {
        payload.serviceTitle = serviceTitle;
        payload.deliveryTimeOption = formData.delivery_time_option;
        payload.deliveryTime = formData.delivery_time;
      }

      navigate(route, { state: payload });
    } catch (error) {
      console.error("Error in handleProceed:", error);
      setDialogMessage("An error occurred. Please try again."); setDialogOpen(true);
    }
  };

  // ─── Styles ────────────────────────────────────────────────────────────────
  const styles = {
    container: { flex: 1, backgroundColor: "#F9FAFB", minHeight: "100vh", paddingBottom: "100px", marginLeft: window.innerWidth >= 900 ? "280px" : 0 }, 
    header: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px", backgroundColor: "#fff", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", position: "sticky", top: 0, zIndex: 1000 },    backButton: { padding: "8px", border: "none", background: "none", cursor: "pointer" },
    headerTitle: { fontSize: "20px", fontWeight: "700", color: "#006D77", margin: 0 },
    scrollContent: { padding: "16px", maxWidth: "900px", margin: "0 auto", width: "90%" },
    card: { backgroundColor: "#fff", borderRadius: "16px", padding: "20px", marginBottom: "16px", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" },
    cardTitle: { fontSize: "18px", fontWeight: "700", color: "#111827", marginBottom: "16px", marginTop: 0 },
    cartItem: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px", backgroundColor: "#F9FAFB", borderRadius: "12px", marginBottom: "12px" },
    itemDetails: { flex: 1 },
    itemName: { fontSize: "15px", fontWeight: "600", color: "#111827", marginBottom: "4px" },
    itemPrice: { fontSize: "14px", color: "#6B7280" },
    quantityControl: { display: "flex", alignItems: "center", gap: "12px" },
    qtyButton: { width: "32px", height: "32px", borderRadius: "8px", border: "1px solid #D1D5DB", backgroundColor: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" },
    qtyText: { fontSize: "16px", fontWeight: "600", minWidth: "24px", textAlign: "center" },
    deleteButton: { padding: "8px", border: "none", background: "none", cursor: "pointer", color: "#EF4444" },
    addressSummary: { padding: "16px", backgroundColor: "#F9FAFB", borderRadius: "12px", marginBottom: "12px" },
    editButton: { display: "flex", alignItems: "center", gap: "8px", padding: "10px 16px", backgroundColor: "#006D77", color: "#fff", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "14px", fontWeight: "600", marginTop: "12px" },
    closeButton: { padding: "8px", border: "none", background: "none", cursor: "pointer", color: "#6B7280", display: "flex", alignItems: "center", gap: "4px", fontSize: "14px", fontWeight: "600" },
    summaryRow: { display: "flex", justifyContent: "space-between", marginBottom: "12px" },
    summaryLabel: { fontSize: "14px", color: "#6B7280" },
    summaryValue: { fontSize: "14px", fontWeight: "600", color: "#111827" },
    divider: { height: "1px", backgroundColor: "#E5E7EB", margin: "12px 0" },
    promoInput: { display: "flex", gap: "8px", marginTop: "12px" },
    input: { flex: 1, border: "1px solid #D1D5DB", borderRadius: "8px", padding: "10px 12px", fontSize: "14px", fontFamily: "inherit" },
    button: { padding: "10px 20px", borderRadius: "8px", border: "none", cursor: "pointer", fontSize: "14px", fontWeight: "600" },
    primaryButton: { backgroundColor: "#006D77", color: "#fff" },
    secondaryButton: { backgroundColor: "#fff", color: "#006D77", border: "1px solid #006D77" },
    dangerButton: { backgroundColor: "#EF4444", color: "#fff" },
    promoTag: { display: "inline-flex", alignItems: "center", gap: "8px", backgroundColor: "#D1FAE5", color: "#065F46", padding: "8px 12px", borderRadius: "8px", fontSize: "14px", fontWeight: "600", marginTop: "8px" },
    promoCard: { border: "1px solid #E5E7EB", borderRadius: "12px", padding: "16px", marginBottom: "12px", cursor: "pointer" },
    inputGroup: { marginBottom: "20px" },
    label: { fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "8px", display: "block" },
    required: { color: "#EF4444" },
    formInput: { width: "100%", border: "1px solid #D1D5DB", borderRadius: "8px", padding: "12px 16px", fontSize: "16px", color: "#111827", backgroundColor: "#fff", boxSizing: "border-box", fontFamily: "inherit" },
    inputError: { borderColor: "#EF4444" },
    errorText: { fontSize: "12px", color: "#EF4444", marginTop: "4px" },
    addressTypeButton: { flex: 1, padding: "12px", borderRadius: "8px", border: "1px solid #D1D5DB", textAlign: "center", cursor: "pointer", backgroundColor: "#fff" },
    addressTypeButtonActive: { backgroundColor: "#006D77", borderColor: "#006D77" },
    addressTypeText: { fontSize: "14px", fontWeight: "600", color: "#6B7280" },
    addressTypeTextActive: { color: "#fff" },
    buttonContainer: { position: "fixed", bottom: 0, left: window.innerWidth >= 900 ? "280px" : 0, right: 0, backgroundColor: "#fff", padding: "16px", boxShadow: "0 -2px 8px rgba(0,0,0,0.1)", zIndex: 1000 },
    proceedButton: { backgroundColor: acceptedTerms ? "#006D77":"#C4C4C4", padding: "16px", borderRadius: "12px", display: "flex", justifyContent: "center", alignItems: "center", border: "none", cursor: "pointer", maxWidth: "900px", margin: "0 auto", width: "100%" },
    proceedButtonText: { color: "#fff", fontSize: "16px", fontWeight: "700", marginRight: "8px" },
    proceedButtonAmount: { color: "#fff", fontSize: "18px", fontWeight: "700" },
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <h1 style={styles.headerTitle}>Delivery Address</h1>
          <div style={{ width: "40px" }} />
        </div>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "200px" }}>
          <p>Loading address...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button onClick={() => navigate(-1)} style={styles.backButton}><ChevronLeft size={24} /></button>
        <h1 style={styles.headerTitle}>Delivery Address</h1>
        <div style={{ width: "40px" }} />
      </div>

      <div style={styles.scrollContent}>

        {/* ─── Cart Items ─────────────────────────────────────────────────────── */}
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>
            {orderType === "diagnostic" ? "Selected Tests" : "Cart Items"} ({cart.length})
          </h2>
          {cart.map((item) => {
            const itemName = orderType === "diagnostic"
              ? (item.test_name || item.name || "Unknown Test")
              : (item.name || item.medicine_name || "Unknown Item");
            const itemId = item.id || item.test_id || item.medicine_id || `item_${Math.random()}`;
            const quantity = Number(item.quantity) || 1;

            // ✅ AYUJA-aware: use discounted_price for medicines (embedded by MedicineListScreen)
            const sellingPrice = orderType === "diagnostic"
              ? (Number(item.non_membership) || Number(item.price) || Number(item.mrp) || 0)
              : (Number(item.discounted_price) || Number(item.price) || 0);
            const mrp = Number(item.price) || Number(item.mrp) || 0;
            const discPct = mrp > sellingPrice ? ((mrp - sellingPrice) / mrp) * 100 : 0;

            return (
              <div key={itemId} style={styles.cartItem}>
                <div style={styles.itemDetails}>
                  <div style={styles.itemName}>{itemName}</div>
                  <div style={styles.itemPrice}>
                  {orderType === "diagnostic" ? (
                      <div>
                        <span>
                          ₹{(sellingPrice * quantity).toFixed(2)}
                          {Number(item.mrp) > 0 && Number(item.mrp) > sellingPrice && (
                            <span style={{ textDecoration: "line-through", color: "#9CA3AF", fontSize: "12px", marginLeft: "6px" }}>
                              MRP ₹{(Number(item.mrp) * quantity).toFixed(2)}
                            </span>
                          )}
                        </span>
                        {quantity > 1 && (
                          <div style={{ fontSize: "11px", color: "#9CA3AF", marginTop: "2px" }}>
                            {quantity} × ₹{sellingPrice.toFixed(2)}
                          </div>
                        )}
                      </div>
                    ) : (
                      <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                          <span style={{ fontSize: '13px', color: '#9CA3AF' }}>
                            MRP ₹{mrp.toFixed(2)}
                          </span>
                        
                        </div>
                  
                      </div>
                    )}
                  </div>
                  {orderType === "diagnostic" && item.test_code && (
                    <div style={{ fontSize: "12px", color: "#9CA3AF", marginTop: "4px" }}>Code: {item.test_code}</div>
                  )}
                </div>

              {orderType !== "diagnostic" ? (
                <div style={styles.quantityControl}>
                  <button onClick={() => updateQuantity(itemId, -1)} style={styles.qtyButton}><Minus size={16} /></button>
                  <span style={styles.qtyText}>{quantity}</span>
                  <button onClick={() => updateQuantity(itemId, 1)} style={styles.qtyButton}><Plus size={16} /></button>
                  {cart.length > 1 && (
                    <button onClick={() => removeItem(itemId)} style={styles.deleteButton}><Trash2 size={18} /></button>
                  )}
                </div>
              ) : (
                <div style={styles.quantityControl}>
                  <button onClick={() => updateDiagnosticQuantity(itemId, -1)} style={styles.qtyButton}><Minus size={16} /></button>
                  <span style={styles.qtyText}>{quantity}</span>
                  <button onClick={() => updateDiagnosticQuantity(itemId, 1)} style={styles.qtyButton}><Plus size={16} /></button>
                  {cart.length > 1 && (
                    <button onClick={() => removeDiagnosticItem(itemId)} style={styles.deleteButton}><Trash2 size={18} /></button>
                  )}
                </div>
              )}
              </div>
            );
          })}
        </div>

        {/* ─── Order Summary ───────────────────────────────────────────────────── */}
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>Order Summary</h2>

          {/* Per-item breakdown (medicine only) */}
          {orderType !== "diagnostic" && cart.map((item, index) => {
            const mrp = Number(item.price) || 0;
            const effectivePrice = Number(item.discounted_price) || mrp;
            const qty = Number(item.quantity) || 1;
            const itemMrpTotal = mrp * qty;
            const itemSellingTotal = effectivePrice * qty;
            const itemSavings = itemMrpTotal - itemSellingTotal;
            const discountPct = mrp > effectivePrice ? ((mrp - effectivePrice) / mrp) * 100 : 0;

            let gstRate = 0;
            if (item.igst && item.igst > 0) gstRate = item.igst;
            else gstRate = (item.cgst || 0) + (item.sgst || 0);
            const baseExclGst = effectivePrice / (1 + gstRate / 100);
            const gstAmount = effectivePrice - baseExclGst;
            const totalBaseExclGst = baseExclGst * qty;
            const totalGstAmount = gstAmount * qty;

            const bp = Number(item.base_price) || 0;
            const maxDiscountPct = bp > 0 && mrp > bp ? ((mrp - bp) / mrp) * 100 : 0;

            return (
              <div key={index} style={{ marginBottom: '16px', border: '1px solid #E5E7EB', borderRadius: '12px', overflow: 'hidden' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 14px', backgroundColor: '#F9FAFB', borderBottom: '1px solid #E5E7EB' }}>
                  <div>
                    <div style={{ fontSize: '15px', fontWeight: '700', color: '#111827' }}>{item.name}</div>
                     {item.selling_unit=="loose_allowed"?(<div style={{ fontSize: '12px', color: '#6B7280', marginTop: '2px' }}>Qty: {qty} </div>):
                    (<div style={{ fontSize: '12px', color: '#6B7280', marginTop: '2px' }}>Qty: {qty}{item.pack_size ? ` • Pack: ${item.pack_size}` : ''}</div>)}
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: '16px', fontWeight: '700', color: '#16a34a' }}>₹{itemSellingTotal.toFixed(2)}</div>
                    {discountPct > 0 && <div style={{ fontSize: '11px', color: '#16a34a', fontWeight: '600', marginTop: '2px' }}>{discountPct.toFixed(1)}% OFF</div>}
                  </div>
                </div>
                <div style={{ padding: '12px 14px', backgroundColor: '#fff' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px', fontSize: '13px' }}>
                    <span style={{ color: '#6B7280' }}>MRP (per unit)</span>
                    <span style={{ color: '#9CA3AF', textDecoration: item.selling_unit=="loose_allowed" && item.quantity<10?'none':'line-through' }}>₹{mrp.toFixed(2)}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px', fontSize: '13px' }}>
                    <span style={{ color: '#6B7280' }}>Selling Price (per unit, incl. GST)</span>
                    <span style={{ color: '#111827', fontWeight: '600' }}>₹{effectivePrice.toFixed(2)}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px', fontSize: '13px' }}>
                    <span style={{ color: '#6B7280' }}>{qty} × ₹{effectivePrice.toFixed(2)}</span>
                    <span style={{ color: '#111827', fontWeight: '600' }}>₹{itemSellingTotal.toFixed(2)}</span>
                  </div>
                  {gstRate > 0 && (
                    <>
                      <div style={{ height: '1px', backgroundColor: '#F3F4F6', margin: '8px 0' }} />
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px', fontSize: '12px' }}>
                        <span style={{ color: '#9CA3AF' }}>Base Price excl. GST</span>
                        <span style={{ color: '#9CA3AF' }}>₹{totalBaseExclGst.toFixed(2)}</span>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px', fontSize: '12px' }}>
                        <span style={{ color: '#9CA3AF' }}>GST ({gstRate}%{item.cgst > 0 && item.sgst > 0 ? ` = CGST ${item.cgst}% + SGST ${item.sgst}%` : item.igst > 0 ? ' IGST' : ''})</span>
                        <span style={{ color: '#9CA3AF' }}>₹{totalGstAmount.toFixed(2)}</span>
                      </div>
                    </>
                  )}
                  {itemSavings > 0 && (
                    <>
                      <div style={{ height: '1px', backgroundColor: '#F3F4F6', margin: '8px 0' }} />
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}>
                        <span style={{ color: '#16a34a', fontWeight: '600' }}>🎉 You save on this item</span>
                        <span style={{ color: '#16a34a', fontWeight: '700' }}>₹{itemSavings.toFixed(2)} ({discountPct.toFixed(1)}% OFF)</span>
                      </div>
                    </>
                  )}
                  {maxDiscountPct > 0 && maxDiscountPct > discountPct && (
                    <div style={{ marginTop: '10px', backgroundColor: '#fff7ed', border: '1px dashed #fed7aa', borderRadius: '8px', padding: '8px 10px', fontSize: '11px', color: '#92400e' }}>
                      💡 Max possible discount on this medicine: <strong>Up to {Math.floor(configuredDiscPct)}% OFF</strong> — final discount depends on your total order value
                    </div>
                  )}
                </div>
              </div>
            );
          })}

          {/* ─── AYUJA Savings Banner ─────────────────────────────────────────── */}
          {/* {orderType !== "diagnostic" && ayujaSavings > 0 && (
            <div style={{ backgroundColor: '#f0fdf4', border: '1px solid #86efac', borderRadius: '10px', padding: '12px 14px', marginBottom: '16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <div style={{ fontSize: '13px', color: '#15803d', fontWeight: '700' }}>🎉 AYUJA Savings</div>
                <div style={{ fontSize: '17px', fontWeight: '800', color: '#15803d' }}>₹{ayujaSavings.toFixed(2)}</div>
              </div>
              <div style={{ backgroundColor: '#fff', borderRadius: '8px', padding: '10px 12px', border: '1px solid #d1fae5' }}>
                {[
                  { label: 'MRP Total',          value: `₹${mrpTotal.toFixed(2)}`,                    style: { textDecoration: 'line-through', color: '#9CA3AF' } },
                  { label: 'Total Discount',     value: `₹${ayujaSavings.toFixed(2)} (${ayujaDiscPct}%)`, style: { color: '#15803d', fontWeight: 700 } },
                  { label: 'Applied Discount %', value: `${perItemDiscPct.toFixed(2)}%`,               style: { color: '#15803d', fontWeight: 700 } },
                  // { label: 'Alpha (α)',           value: orderMaxDiscPct > 0 ? alphaValue.toFixed(4) : '-', style: { color: '#111827', fontWeight: 600 } },
                  { label: 'Payable',         value: `₹${sellingTotal.toFixed(2)}`,                style: { color: '#006d77', fontWeight: 700 } },
                ].map(({ label, value, style }) => (
                  <div key={label} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5, fontSize: 12 }}>
                    <span style={{ color: '#6B7280' }}>{label}</span>
                    <span style={style}>{value}</span>
                  </div>
                ))}
              </div>
              {wasCapped && (
                <div style={{ marginTop: 8, backgroundColor: '#fff7ed', border: '1px solid #fed7aa', borderRadius: 7, padding: '7px 10px', fontSize: 11, color: '#92400e' }}>
                  ⚠️ Configured discount <strong>{configuredDiscPct}%</strong> was reduced to <strong>{perItemDiscPct.toFixed(2)}%</strong> to protect minimum profit rule.
                </div>
              )}
            </div>
          )} */}

          <div style={styles.divider} />

          {/* Bill rows */}
          {orderType !== "diagnostic" && (
            <div style={styles.summaryRow}>
              <span style={styles.summaryLabel}>MRP Total</span>
              <span style={{ ...styles.summaryValue,  color: '#9CA3AF' }}>₹{mrpTotal.toFixed(2)}</span>
            </div>
          )}

          {orderType !== "diagnostic" && ayujaSavings > 0 && (
            <div style={{ ...styles.summaryRow, backgroundColor: '#f0fdf4', padding: '8px 12px', borderRadius: '8px', margin: '4px 0' }}>
              <span style={{ color: '#16a34a', fontWeight: 600, fontSize: '14px' }}>🎉 AYUJA Savings ({ayujaDiscPct}% OFF)</span>
              <span style={{ color: '#16a34a', fontWeight: 700 }}>-₹{ayujaSavings.toFixed(2)}</span>
            </div>
          )}

          <div style={styles.summaryRow}>
            <span style={styles.summaryLabel}>
              Subtotal ({cart.length} {orderType === "diagnostic" ? "test" : "item"}{cart.length > 1 ? "s" : ""})
            </span>
            <div style={{ textAlign: "right" }}>
              {orderType === "diagnostic" && diagnosticSavings > 0 && (
                <div style={{ fontSize: "12px", color: "#9CA3AF", textDecoration: "line-through", marginBottom: "2px" }}>
                  MRP ₹{mrpTotal.toFixed(2)}
                </div>
              )}
              <span style={styles.summaryValue}>₹{sellingTotal.toFixed(2)}</span>
            </div>
          </div>

          {orderType === "diagnostic" && diagnosticSavings > 0 && (
            <div style={styles.summaryRow}>
              <span style={{ ...styles.summaryLabel, color: "#10B981", fontWeight: "600" }}>You Save</span>
              <span style={{ ...styles.summaryValue, color: "#10B981" }}>-₹{diagnosticSavings.toFixed(2)}</span>
            </div>
          )}

          {subscriptionBenefits?.has_subscription && subscriptionDiscount > 0 && (
            <div style={styles.summaryRow}>
              <span style={{ ...styles.summaryLabel, color: "#8B5CF6" }}>
                🎁 Subscription ({subscriptionBenefits.benefits.medicine_discount}%)
                <div style={{ fontSize: "11px", color: "#9CA3AF", marginTop: "2px" }}>{subscriptionBenefits.subscription.name}</div>
              </span>
              <span style={{ ...styles.summaryValue, color: "#8B5CF6" }}>-₹{subscriptionDiscount.toFixed(2)}</span>
            </div>
          )}

          {appliedPromo && (
            <div>
            <div style={styles.summaryRow}>
              <span style={{ ...styles.summaryLabel, color: "#d97706", fontWeight: "600" }}>🏷️ Promo ({appliedPromo.code})</span>
              <span style={{ ...styles.summaryValue, color: "#d97706" }}>-₹{appliedPromo.discount.toFixed(2)}</span>
            </div>
             {appliedPromo.affected_tests?.map((test, index) => (
              <div
                key={index}
                style={{
                  display: "flex", 
                  justifyContent: "space-between",
                  marginBottom: "12px" ,
                  fontSize: "12px",
                  color: "#d82972"
                }}
              >
                <span>{test.test_name}</span>
                <div>
                <span style={{ textDecoration: "line-through", color: "#9CA3AF" }}>
                  ₹{test.original_price}
                </span>
                {" → "}
                <span style={{ color: "#10B981", fontWeight: 600 }}>
                  ₹{test.fixed_price || (test.original_price-test.discount)}
                </span>
              </div>
              </div>
            ))}
            </div>
          )}
          <div style={styles.summaryRow}>
            <span style={styles.summaryLabel}>Delivery Charge</span>
            <span style={styles.summaryValue}>
              {deliveryCharge === 0
                ? <><span style={{ textDecoration: "line-through", color: "gray" }}>₹50</span>{' '}<span style={{ color: '#16a34a', fontWeight: 600 }}>FREE</span></>
                : `₹${deliveryCharge}`}
            </span>
          </div>

          <div style={styles.divider} />

          <div style={{ ...styles.summaryRow, marginTop: 8 }}>
            <span style={{ fontSize: "16px", fontWeight: "700", color: "#111827" }}>Total Payable</span>
            <span style={{ fontSize: "20px", fontWeight: "700", color: "#006D77" }}>₹{finalAmount.toFixed(2)}</span>
          </div>

          {/* Promo section */}
          {!appliedPromo ? (
            <>
              <div style={styles.promoInput}>
                <input type="text" placeholder="Enter promo code" value={promoCode}
                  onChange={(e) => setPromoCode(e.target.value.toUpperCase())} style={styles.input} />
                <button onClick={() => applyPromoCode(promoCode)} disabled={!promoCode || promoLoading}
                  style={{ ...styles.button, ...styles.primaryButton, opacity: !promoCode ? 0.5 : 1 }}>
                  {promoLoading ? "Applying..." : "Apply"}
                </button>
              </div>
              <button onClick={() => setShowAvailablePromos(!showAvailablePromos)}
                style={{ ...styles.button, ...styles.secondaryButton, width: "100%", marginTop: "8px", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                <Tag size={16} /> View Available Offers
                {showAvailablePromos ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
              </button>
              {subscriptionBenefits?.has_subscription && (
                <div style={{ backgroundColor: "#F3E8FF", padding: "12px", borderRadius: "8px", marginTop: "12px", border: "1px solid #DDD6FE" }}>
                  <div style={{ fontSize: "14px", fontWeight: "600", color: "#7C3AED" }}>🎉 Active Subscription</div>
                  <div style={{ fontSize: "12px", color: "#6B7280", marginTop: 4 }}>Saving {subscriptionBenefits.benefits.medicine_discount}% on medicine orders</div>
                  <div style={{ fontSize: "11px", color: "#9CA3AF", marginTop: 4 }}>{subscriptionBenefits.subscription.days_remaining} days remaining</div>
                </div>
              )}
              {showAvailablePromos && availablePromos.length > 0 && (
                <div style={{ marginTop: "12px" }}>
                  {availablePromos.map((promo, index) => (
                    <div key={index} style={styles.promoCard}
                      onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#006D77"; e.currentTarget.style.backgroundColor = "#F0FDFA"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#E5E7EB"; e.currentTarget.style.backgroundColor = "#fff"; }}
                      onClick={() => applyPromoCode(promo.promo_code)}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
                        <div>
                          <div style={{ fontSize: "16px", fontWeight: "700", color: "#111827", marginBottom: "4px" }}>{promo.promo_code}
                            {promo.fixed_price > 0 && (
                              <span style={{
                                marginLeft: "8px",
                                background: "#DCFCE7",
                                color: "#166534",
                                padding: "2px 6px",
                                borderRadius: "6px",
                                fontSize: "11px",
                                fontWeight: 600
                              }}>
                                ₹{promo.fixed_price} ONLY
                              </span>
                            )}
                          </div>
                          <div style={{ fontSize: "14px", color: "#6B7280", marginBottom: "8px" }}>{promo.description}</div>
                         <div style={{ fontSize: "12px", color: "#9CA3AF" }}>
                            Min order: ₹{promo.min_order_value}
                            {promo.fixed_price > 0
                              ? ` • Fixed Price: ₹${promo.fixed_price}`
                              : promo.max_discount > 0
                                ? ` • Max discount: ₹${promo.max_discount}`
                                : ""}
                          </div>
                        </div>
                        <button style={{ ...styles.button, ...styles.primaryButton, fontSize: "12px", padding: "6px 12px" }}>Apply</button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          ) : (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={styles.promoTag}><Tag size={16} />{appliedPromo.code} Applied</div>
              <button onClick={removePromoCode} style={{ ...styles.button, ...styles.dangerButton, fontSize: "12px", padding: "6px 12px" }}>Remove</button>
            </div>
          )}
        </div>

        {/* ─── Address Form ────────────────────────────────────────────────────── */}
        <div style={styles.card}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
            <h2 style={{ ...styles.cardTitle, marginBottom: 0 }}>Delivery Details</h2>
            {isEditingAddress && (
              <button onClick={handleCancelEdit} style={styles.closeButton}><X size={20} /><span>Close</span></button>
            )}
          </div>

          {!isEditingAddress ? (
            <>
              <div style={styles.addressSummary}>
                <div style={{ fontSize: "16px", fontWeight: "600", color: "#111827", marginBottom: "8px" }}>{formData.full_name}</div>
                <div style={{ fontSize: "14px", color: "#6B7280", marginBottom: "4px" }}>{formData.email}</div>
                <div style={{ fontSize: "14px", color: "#6B7280", marginBottom: "4px" }}>{formData.phone}</div>
                <div style={{ fontSize: "14px", color: "#6B7280", lineHeight: "1.6" }}>
                  {formData.address_line2 && `${formData.address_line2}, `}
                  {formData.address_line1}, {formData.community_name}
                  {formData.landmark && `, ${formData.landmark}`}
                </div>
                <div style={{ fontSize: "14px", color: "#6B7280", marginTop: "8px" }}>
                  <strong>Delivery Time:</strong>{" "}
                  {formData.delivery_time_option === "anytime" ? "Anytime" : formData.delivery_time || "Not selected"}
                </div>
              </div>
              <button onClick={handleEditAddress} style={styles.editButton}><Edit2 size={16} /> Add Address</button>
            </>
          ) : (
            <>
              {[
                { field: "full_name", label: "Full Name", type: "text", placeholder: "Enter your full name" },
                { field: "email", label: "Email", type: "email", placeholder: "Enter your email address" },
              ].map(({ field, label, type, placeholder }) => (
                <div key={field} style={styles.inputGroup}>
                  <label style={styles.label}>{label} {field !== "email" && <span style={styles.required}>*</span>}</label>
                  <input type={type} style={{ ...styles.formInput, ...(errors[field] ? styles.inputError : {}) }}
                    placeholder={placeholder} value={formData[field]}
                    onChange={(e) => handleInputChange(field, e.target.value)} />
                  {errors[field] && <p style={styles.errorText}>{errors[field]}</p>}
                </div>
              ))}

              <div style={styles.inputGroup}>
                <label style={styles.label}>Phone Number <span style={styles.required}>*</span></label>
                <input type="tel" style={{ ...styles.formInput, ...(errors.phone ? styles.inputError : {}) }}
                  placeholder="Enter 10-digit phone number" value={formData.phone}
                  onChange={(e) => handleInputChange("phone", e.target.value.replace(/\D/g, "").slice(0, 10))} maxLength={10} />
                {errors.phone && <p style={styles.errorText}>{errors.phone}</p>}
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>Community/Society Name <span style={styles.required}>*</span></label>
                <select style={{ ...styles.formInput, ...(errors.community_name ? styles.inputError : {}) }}
                  value={formData.community_name} onChange={(e) => handleInputChange("community_name", e.target.value)}>
                  <option value="">Select Community</option>
                   {communities.map((c) => <option key={c.name} value={c.name}>{c.name}</option>)}
                </select>
                {errors.community_name && <p style={styles.errorText}>{errors.community_name}</p>}
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>Block/Building <span style={styles.required}>*</span></label>
                <select style={{ ...styles.formInput, ...(errors.address_line1 ? styles.inputError : {}) }}
                  value={formData.address_line1} onChange={(e) => handleInputChange("address_line1", e.target.value)}>
                  <option value="">Select Block</option>
                  {BLOCK_OPTIONS.map((b) => <option key={b} value={b}>{b}</option>)}
                </select>
                {errors.address_line1 && <p style={styles.errorText}>{errors.address_line1}</p>}
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>Flat/House Number</label>
                <input type="text" style={styles.formInput} placeholder="Flat or House Number"
                  value={formData.address_line2} onChange={(e) => handleInputChange("address_line2", e.target.value)} />
              </div>

              {/* Delivery time */}
              <div style={styles.inputGroup}>
                <label style={styles.label}>Preferred Delivery Time <span style={styles.required}>*</span></label>
                <div style={{ display: "flex", gap: "12px" }}>
                  {["anytime", "specific"].map((option) => (
                    <button key={option} type="button"
                      style={{ ...styles.addressTypeButton, ...(formData.delivery_time_option === option ? styles.addressTypeButtonActive : {}) }}
                      onClick={() => { handleInputChange("delivery_time_option", option); setSelectedDate(""); setSelectedSlot(""); setAvailableSlots([]); setErrors(prev => ({ ...prev, selecctedDate: "", delivery_time: "" })); }}>
                      <span style={{ ...styles.addressTypeText, ...(formData.delivery_time_option === option ? styles.addressTypeTextActive : {}) }}>
                        {option === "anytime" ? "Anytime" : "Specific Time"}
                      </span>
                    </button>
                  ))}
                </div>
              </div>

              {formData.delivery_time_option === "specific" && (
                <>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Select Date <span style={styles.required}>*</span></label>
                    <input type="date" value={selecctedDate}
                      min={new Date().toISOString().split("T")[0]}
                      max={(() => { const d = new Date(); d.setDate(d.getDate() + 10); return d.toISOString().split("T")[0]; })()}
                      onChange={(e) => handleDateChange(e.target.value)}
                      onKeyDown={(e) => e.preventDefault()}
                      onClick={(e) => e.currentTarget.showPicker()}
                      style={{ ...styles.formInput, cursor: "pointer", ...(errors.selecctedDate ? styles.inputError : {}) }} />
                    {errors.selecctedDate && <p style={styles.errorText}>{errors.selecctedDate}</p>}
                  </div>
                  {selecctedDate && availableSlots.length > 0 && (
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>Available Time Slots <span style={styles.required}>*</span></label>
                      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        {availableSlots.map((slot, index) => (
                          <button key={index} type="button" disabled={slot.disabled}
                            onClick={() => { setSelectedSlot(slot.label); handleInputChange("delivery_time", `${selecctedDate} | ${slot.label}`); setErrors(prev => ({ ...prev, delivery_time: "" })); }}
                            style={{ padding: "12px", borderRadius: "12px", border: "1px solid #ccc", background: selectedSlot === slot.label ? "#006D77" : slot.disabled ? "#eee" : "#fff", color: selectedSlot === slot.label ? "#fff" : slot.disabled ? "#999" : "#333", cursor: slot.disabled ? "not-allowed" : "pointer", fontWeight: 600 }}>
                            ⏱ {slot.label} {slot.disabled ? "(Unavailable)" : ""}
                          </button>
                        ))}
                      </div>
                      {errors.delivery_time && <p style={styles.errorText}>{errors.delivery_time}</p>}
                    </div>
                  )}
                </>
              )}

              <button onClick={() => {handleSaveAddress(formData);setIsEditingAddress(false)}}
                style={{ ...styles.button, ...styles.secondaryButton, width: "100%", marginTop: "12px" }}>
                Save Address
              </button>
            </>
          )}
        </div>
      </div>

      {/* ─── Proceed Button ──────────────────────────────────────────────────── */}
      <div style={styles.buttonContainer}>
         <FormControlLabel style={{paddingBottom:16,display: "flex", justifyContent: "center", alignItems: "center",}}
                      
                      control={
                        <Checkbox
                          size="small"
                          checked={acceptedTerms || false}
                          onChange={(e) => setAcceptedTerms(e.target.checked)}
                        />
                      }
                      label={
                        <Typography variant="body2">
                          Accept Ayuja's{" "}
                          <a href="/terms&conditions" target="_blank" rel="noopener noreferrer"
                            style={{ color: "#007a85", fontWeight: "bold", textDecoration: "none" }}>
                            Terms and Conditions
                          </a>
                            <span style={{ color: "red", marginLeft: 2 ,fontSize:19}}>*</span>
                        </Typography>
                      }
                    />
        <button style={styles.proceedButton} onClick={handleProceed} disabled={!acceptedTerms}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor =acceptedTerms ?  "#005761":"#C4C4C4")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor =acceptedTerms ?  "#006D77":"#C4C4C4")}>
          <span style={styles.proceedButtonText}>
            {orderType === "diagnostic" ? "Confirm & Pay" : "Proceed to Payment"}
          </span>
          <span style={styles.proceedButtonAmount}>₹{finalAmount.toFixed(2)}</span>
        </button>
      </div>

      <CustomDialog open={dialogOpen} message={dialogMessage} title={promoMsg} type={promotype} onClose={() => setDialogOpen(false)} />
    </div>
  );
};

export default MedicineDeliveryAddressScreen;